import React from 'react';
import { parseEventDescription } from '../lib/event-description';
import './EventDescription.css';

const LINK_RE = /([\w.+-]+@[\w-]+(?:\.[\w-]+)+|(?:https?:\/\/|www\.)[^\s]*[^\s.,;:!?)])/gi;

function linkify(text: string): React.ReactNode[] {
  return text.split(LINK_RE).map((part, i) => {
    if (i % 2 === 0) return part;
    const href = part.includes('@') && !part.includes('/')
      ? `mailto:${part}`
      : part.startsWith('http')
        ? part
        : `https://${part}`;
    return (
      <a key={i} href={href} target={href.startsWith('mailto:') ? undefined : '_blank'} rel="noopener noreferrer">
        {part}
      </a>
    );
  });
}

type Props = {
  text: string | null | undefined;
};

const EventDescription: React.FC<Props> = ({ text }) => {
  const blocks = parseEventDescription(text);
  if (!blocks.length) return null;

  return (
    <div className="event-description">
      {blocks.map((block, i) => {
        if (block.type === 'heading') {
          return <h5 key={i} className="event-description-heading">{block.text}</h5>;
        }
        if (block.type === 'list') {
          return (
            <ul key={i}>
              {block.items.map((item, j) => (
                <li key={j}>
                  {linkify(item.text)}
                  {item.children.length > 0 && (
                    <ul>
                      {item.children.map((child, k) => (
                        <li key={k}>{linkify(child)}</li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i}>
            {block.lines.map((line, j) => (
              <React.Fragment key={j}>
                {j > 0 && <br />}
                {linkify(line)}
              </React.Fragment>
            ))}
          </p>
        );
      })}
    </div>
  );
};

export default EventDescription;
